import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchQuestSkills } from '../../../actions/questskills'
import Intro5am from '../../typography/Intro5am'
import SkillAdd from '../skills/SkillAdd'
import SkillsList from '../skills/SkillsList'

class Skills extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchQuestSkills())
  }

  render() {
    const { skills, isFetching, dispatch, allowEdit, frameworkSkills } =
      this.props

    const skillsIds = skills.map(s => s.framework_skill_id)
    const filteredSkills = frameworkSkills.filter(
      s => !skillsIds.includes(s.id)
    )

    if (isFetching) {
      return <div className="loading" />
    }

    return (
      <div className="skills">
        {allowEdit && (
          <SkillAdd dispatch={dispatch} frameworkSkills={filteredSkills} />
        )}

        {skills.length === 0 ? (
          <Intro5am style={{ margin: '44px auto', textAlign: 'center' }}>
            No skills are linked to this quest.
          </Intro5am>
        ) : (
          <SkillsList
            skills={skills}
            dispatch={dispatch}
            allowEdit={allowEdit}
          />
        )}
      </div>
    )
  }
}

export const mapStateToProps = state => ({
  isFetching: state.quest.isFetchingQuestSkills,
  skills: state.quest.skills,
  frameworkSkills: state.frameworkskills.items
})

Skills.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  skills: PropTypes.array.isRequired,
  allowEdit: PropTypes.bool.isRequired,
  frameworkSkills: PropTypes.array.isRequired
}

export default connect(mapStateToProps)(Skills)
export { Skills as SkillsDisconnected }



// WEBPACK FOOTER //
// ./src/components/quest/section/Skills.js